import React, { useState } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import wave from '../resource/wave_final.png';
import kgvHero from '../resource/kgvhero1.png';
import indiaMap from '../resource/india.png';
import { FaCheckCircle, FaRupeeSign, FaMapMarkerAlt, FaShieldAlt, FaHandshake, FaChartLine, FaHeadset, FaLeaf } from 'react-icons/fa';
import { Sparkles } from 'lucide-react';

const Distrubuter = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    fatherName: '',
    dob: '',
    phone: '',
    email: '',
    idProofType: '',
    idNumber: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    termsAccepted: false
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const { fullName, fatherName, dob, phone, email, idProofType, idNumber, address1, address2, city, state, termsAccepted } = formData;

  // Handle input fields, when some value changes
  const handleOnChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  // Handle Form Submission
  const handleOnSubmit = async (e) => {
    e.preventDefault();

    // Validation
    if (!termsAccepted) {
      toast.error('Please accept the terms and conditions', {
        position: "bottom-right",
        autoClose: 3000,
      });
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await axios.post("https://auth.kgvl.co.in/api/distributor/apply", {
        fullName,
        fatherName,
        dob,
        phone,
        email,
        idProofType,
        idNumber,
        address1,
        address2,
        city,
        state,
        termsAccepted,
      });

      if (response.status === 200 || response.status === 201 || response.data.success) {
        console.log(response.data);
        console.log("Distributor application submitted successfully!");

        // Show success toast
        toast.success('Application submitted successfully! We will contact you within 24-48 hours.', {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        // Reset form
        setFormData({
          fullName: '',
          fatherName: '',
          dob: '',
          phone: '',
          email: '',
          idProofType: '',
          idNumber: '',
          address1: '',
          address2: '',
          city: '',
          state: '',
          termsAccepted: false
        });
      } else {
        console.error("Failed to submit application.");
        toast.error('Failed to submit application. Please try again.', {
          position: "bottom-right",
          autoClose: 3000,
        });
      }
    } catch (error) {
      console.error("Error submitting application:", error);

      // Show error toast with details
      const errorMessage = error.response?.data?.message || error.message || "An error occurred";
      toast.error(`Error: ${errorMessage}`, {
        position: "bottom-right",
        autoClose: 5000,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="relative w-full bg-gradient-to-b from-white to-green-50 overflow-hidden">
      {/* Animated Background Wave */}
      <div className="absolute inset-0 overflow-hidden z-0">
        <img
          src={wave}
          className="w-full h-full object-cover opacity-60 animate-float"
          alt="wave background"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-green-50/30 to-blue-50/30"></div>
      </div>

      <ToastContainer />

      <div className="relative z-10 py-16 px-4 sm:px-6 lg:px-8">

        {/* Hero Section */}
        <div className="text-center mb-12">
          {/* Premium AI Badge */}
          <div className="z-10 mb-6 flex justify-center group transition-all duration-500 hover:scale-110 active:scale-95">
            <span className="relative overflow-hidden bg-black/90 backdrop-blur-xl px-5 py-2.5 rounded-full shadow-[0_0_20px_rgba(34,197,94,0.4)] flex items-center gap-3 border border-green-500/50">
              <span className="absolute inset-0 w-1/2 h-full bg-gradient-to-r from-transparent via-white/20 to-transparent -rotate-45 shimmer-sweep"></span>
              <Sparkles className="w-4 h-4 text-green-400 animate-pulse" />
              <span className="text-white text-[10px] sm:text-xs font-black tracking-[0.2em] uppercase">
                AI-POWERED <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-400 to-emerald-400">NETWORK GROWTH</span>
              </span>
            </span>
          </div>

          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4 animate-fade-in">
            Become a <span className="text-green-600">KGV Distributor</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Join India's Green Revolution & <span className="font-bold text-green-700">AI-Optimized</span> Business Expansion
          </p>
        </div>

        {/* Join Today Section */}
        <div className="bg-gradient-to-r from-green-50 to-white rounded-3xl shadow-2xl p-8 md:p-12 text-center max-w-6xl mx-auto mb-16 transform transition-all hover:scale-[1.02] duration-300 border border-green-100">
          <div className="inline-flex items-center bg-green-100 text-green-800 px-6 py-2 rounded-full font-semibold mb-6">
            <FaLeaf className="mr-2" /> Limited Opportunity
          </div>

          <h2 className="text-3xl font-bold text-gray-800 mb-4">
            <span className="text-green-600">Join hands with KGV Today</span>
          </h2>
          <h3 className="text-xl font-semibold text-gray-700 mb-6">
            <span className="bg-gradient-to-r from-green-600 to-blue-600 bg-clip-text text-transparent">
              #KgvLaoClimateBachao #ChaiSeSastiRide
            </span>
          </h3>

          <button className="bg-gradient-to-r from-green-600 to-green-700 text-white px-8 py-3 rounded-full font-bold text-lg hover:from-green-700 hover:to-green-800 transform hover:-translate-y-1 transition-all duration-300 shadow-lg hover:shadow-xl my-4">
            <FaHandshake className="inline mr-2" /> LET'S TEAM UP
          </button>

          <p className="text-gray-700 text-lg mb-8 leading-relaxed">
            Are you passionate about sustainable mobility and interested in bringing the joy of riding
            KGV hybrid bikes to your community? Join us as a distributor and be a part of our journey
            to redefine urban commuting while building a profitable business!
          </p>

          <div className="mt-8 space-y-6">
            {/* Earnings Highlight */}
            <div className="bg-gradient-to-br from-green-50 to-white p-6 rounded-2xl border border-green-200">
              <div className="flex flex-col md:flex-row items-center justify-center gap-4">
                <button className="bg-gradient-to-r from-green-600 to-green-700 text-white px-8 py-3 rounded-full font-semibold hover:from-green-700 hover:to-green-800 transition-all duration-300 whitespace-nowrap">
                  Embrace sustainability with a chance of earning up to
                </button>
                <div className="text-center">
                  <div className="flex items-center justify-center gap-2">
                    <FaRupeeSign className="text-green-800 text-3xl" />
                    <span className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-green-800 to-green-600 bg-clip-text text-transparent">
                      7-10 Lakhs/month*
                    </span>
                  </div>
                  <p className="text-sm text-gray-600 mt-2">*Based on current distributor performance</p>
                </div>
              </div>
            </div>

            {/* Exclusive Territory */}
            <button className="bg-gradient-to-r from-blue-600 to-green-600 text-white px-8 py-3 rounded-full font-semibold hover:from-blue-700 hover:to-green-700 transform hover:scale-105 transition-all duration-300 shadow-lg">
              <FaMapMarkerAlt className="inline mr-2" /> One Distributor One District
            </button>
          </div>
        </div>

        {/* Benefits Section */}
        <div className="max-w-6xl mx-auto mb-16">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-10">
            Why Become a <span className="text-green-600">KGV Distributor?</span>
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {[
              { icon: <FaRupeeSign />, title: "High Profit Margins", desc: "Industry-best margins with no middlemen" },
              { icon: <FaShieldAlt />, title: "Exclusive Territory", desc: "Protected geographical area for your business" },
              { icon: <FaHeadset />, title: "Full Support", desc: "Marketing, training & technical support" },
              { icon: <FaChartLine />, title: "Growing Market", desc: "Tap into the booming EV & bicycle market" }
            ].map((benefit, index) => (
              <div key={index} className="bg-white p-6 rounded-2xl shadow-lg border border-green-100 hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300">
                <div className="text-green-600 text-3xl mb-4">{benefit.icon}</div>
                <h3 className="font-bold text-lg text-gray-800 mb-2">{benefit.title}</h3>
                <p className="text-gray-600">{benefit.desc}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Form Section */}
        <div className="bg-white rounded-3xl shadow-2xl p-6 md:p-8 mt-12 max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16">
          <div>
            <h3 className="text-2xl font-bold text-gray-800 mb-6">
              Apply Now & Join the <span className="text-green-600">Green Revolution</span>
            </h3>

            <form onSubmit={handleOnSubmit} className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">
                    Full Name <sup className="text-red-500">*</sup>
                  </label>
                  <div className="flex items-center bg-white p-2 rounded-xl border border-green-500">
                    <input
                      required
                      name="fullName"
                      value={fullName}
                      onChange={handleOnChange}
                      className="w-full outline-none"
                      placeholder="Enter your name"
                      disabled={isSubmitting}
                    />
                  </div>
                </div>

                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">Father's Name</label>
                  <div className="flex items-center bg-white p-2 rounded-xl border border-green-500">
                    <input
                      name="fatherName"
                      value={fatherName}
                      onChange={handleOnChange}
                      className="w-full outline-none"
                      placeholder="Father's name"
                      disabled={isSubmitting}
                    />
                  </div>
                </div>

                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">Date of Birth</label>
                  <div className="flex items-center bg-white p-2 rounded-xl border border-green-500">
                    <input
                      type="date"
                      name="dob"
                      value={dob}
                      onChange={handleOnChange}
                      className="w-full outline-none"
                      disabled={isSubmitting}
                    />
                  </div>
                </div>

                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">
                    Phone Number <sup className="text-red-500">*</sup>
                  </label>
                  <div className="flex items-center bg-white p-2 rounded-xl border border-green-500">
                    <input
                      required
                      name="phone"
                      value={phone}
                      onChange={handleOnChange}
                      className="w-full outline-none"
                      placeholder="10-digit mobile number"
                      disabled={isSubmitting}
                    />
                  </div>
                </div>

                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">
                    Email <sup className="text-red-500">*</sup>
                  </label>
                  <div className="flex items-center bg-white p-2 rounded-xl border border-green-500">
                    <input
                      required
                      type="email"
                      name="email"
                      value={email}
                      onChange={handleOnChange}
                      className="w-full outline-none"
                      placeholder="your.email@example.com"
                      disabled={isSubmitting}
                    />
                  </div>
                </div>

                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">
                    Identification Proof <sup className="text-red-500">*</sup>
                  </label>
                  <div className="flex items-center bg-white p-2 rounded-xl border border-green-500">
                    <select
                      required
                      name="idProofType"
                      value={idProofType}
                      onChange={handleOnChange}
                      className="w-full outline-none"
                      disabled={isSubmitting}
                    >
                      <option value="">Select Identification Proof</option>
                      <option value="Aadhaar Card">Aadhaar Card</option>
                      <option value="Driving License">Driving License</option>
                      <option value="PAN Card">PAN Card</option>
                      <option value="Passport">Passport</option>
                    </select>
                  </div>
                </div>

                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">
                    ID Number <sup className="text-red-500">*</sup>
                  </label>
                  <div className="flex items-center bg-white p-2 rounded-xl border border-green-500">
                    <input
                      required
                      name="idNumber"
                      value={idNumber}
                      onChange={handleOnChange}
                      className="w-full outline-none"
                      placeholder="Enter ID number"
                      disabled={isSubmitting}
                    />
                  </div>
                </div>

                <div className="md:col-span-2 space-y-2">
                  <label className="text-sm font-medium text-gray-700">
                    Address Line 1 <sup className="text-red-500">*</sup>
                  </label>
                  <div className="flex items-center bg-white p-2 rounded-xl border border-green-500">
                    <input
                      required
                      name="address1"
                      value={address1}
                      onChange={handleOnChange}
                      className="w-full outline-none"
                      placeholder="Street address"
                      disabled={isSubmitting}
                    />
                  </div>
                </div>

                <div className="md:col-span-2 space-y-2">
                  <label className="text-sm font-medium text-gray-700">Address Line 2</label>
                  <div className="flex items-center bg-white p-2 rounded-xl border border-green-500">
                    <input
                      name="address2"
                      value={address2}
                      onChange={handleOnChange}
                      className="w-full outline-none"
                      placeholder="Apartment, suite, etc."
                      disabled={isSubmitting}
                    />
                  </div>
                </div>

                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">
                    City <sup className="text-red-500">*</sup>
                  </label>
                  <div className="flex items-center bg-white p-2 rounded-xl border border-green-500">
                    <input
                      required
                      name="city"
                      value={city}
                      onChange={handleOnChange}
                      className="w-full outline-none"
                      placeholder="Your city"
                      disabled={isSubmitting}
                    />
                  </div>
                </div>

                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700">
                    State <sup className="text-red-500">*</sup>
                  </label>
                  <div className="flex items-center bg-white p-2 rounded-xl border border-green-500">
                    <input
                      required
                      name="state"
                      value={state}
                      onChange={handleOnChange}
                      className="w-full outline-none"
                      placeholder="Your state"
                      disabled={isSubmitting}
                    />
                  </div>
                </div>
              </div>

              <div className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  id="terms"
                  name="termsAccepted"
                  checked={termsAccepted}
                  onChange={handleOnChange}
                  className="rounded text-green-600 focus:ring-green-500"
                  disabled={isSubmitting}
                />
                <label htmlFor="terms" className="text-sm text-gray-600">
                  I agree to the terms and conditions and privacy policy <sup className="text-red-500">*</sup>
                </label>
              </div>

              <div className="flex justify-center">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="bg-[#57E226] hover:bg-green-600 text-white font-semibold px-8 py-3 rounded-xl transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed transform hover:-translate-y-1 shadow-lg"
                >
                  {isSubmitting ? (
                    <span>Submitting...</span>
                  ) : (
                    <>
                      <FaCheckCircle className="inline mr-2" /> Join the KGV Family
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>

          <div className="flex flex-col justify-center items-center p-4">
            <div className="relative w-full max-w-md">
              <img
                src={kgvHero}
                alt="KGV Hero"
                className="w-full h-auto object-contain rounded-3xl shadow-2xl transform hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute -bottom-4 -right-4 bg-green-600 text-white px-6 py-2 rounded-full font-bold shadow-lg">
                Made in India
              </div>
            </div>

            <div className="mt-8 text-center">
              <h4 className="text-xl font-bold text-gray-800 mb-3">Quick Response Guaranteed</h4>
              <div className="flex items-center justify-center space-x-4 text-gray-600">
                <div className="text-center">
                  <div className="text-2xl font-bold text-green-600">24-48</div>
                  <div className="text-sm">Hours Response</div>
                </div>
                <div className="h-8 w-px bg-gray-300"></div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-green-600">100%</div>
                  <div className="text-sm">Support</div>
                </div>
                <div className="h-8 w-px bg-gray-300"></div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-green-600">0%</div>
                  <div className="text-sm">Hidden Costs</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Ride Care-free Section */}
        <div className="bg-gradient-to-r from-white to-blue-50 rounded-3xl shadow-2xl p-6 md:p-8 mt-12 max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16 border border-blue-100">
          <div className="relative">
            <img
              src={indiaMap}
              alt="India Map"
              className="w-full h-auto rounded-2xl shadow-lg"
            />
            <div className="absolute bottom-4 left-4 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-xl shadow">
              <div className="text-sm font-bold text-green-700">750+</div>
              <div className="text-xs text-gray-600">Districts Available</div>
            </div>
          </div>

          <div className="flex flex-col justify-center p-4 md:p-6 space-y-6">
            <div className="bg-gradient-to-r from-orange-100 to-orange-50 text-orange-800 text-center font-bold text-xl md:text-2xl rounded-2xl px-6 py-6 border border-orange-200 transform hover:scale-[1.02] transition-all duration-300">
              <FaShieldAlt className="inline mr-2" /> RIDE CARE-FREE WITH KGV SMART MOBILITY
            </div>

            <div className="bg-gradient-to-r from-gray-50 to-white text-gray-700 text-center rounded-2xl px-6 py-6 border border-gray-200 transform hover:scale-[1.02] transition-all duration-300">
              Ride carefree with KGV Smart Mobility! Cut your travel expenses by 90%.
              Enjoy a hassle-free, stress-free journey while contributing to a cleaner environment!
            </div>

            <div className="bg-gradient-to-r from-green-50 to-emerald-50 text-green-800 text-center font-semibold rounded-2xl px-6 py-6 border border-green-200 transform hover:scale-[1.02] transition-all duration-300">
              <div className="flex items-center justify-center space-x-2 mb-2">
                <div className="bg-white px-3 py-1 rounded-full text-sm font-bold text-green-700">Make in India</div>
                <div className="bg-white px-3 py-1 rounded-full text-sm font-bold text-green-700">Atmanirbhar Bharat</div>
              </div>
              For the first time ever, India has its own patented technology driven by national initiatives.
              KGV introduces a unique innovation: converting regular bikes like never before.
            </div>
          </div>
        </div>

        {/* Testimonial/Stats Section */}
        <div className="max-w-6xl mx-auto mb-16">
          <h3 className="text-2xl font-bold text-center text-gray-800 mb-8">
            Our <span className="text-green-600">Distributors Speak</span>
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              { name: "Rajesh Kumar", city: "Pune", quote: "Best decision of my life! Earning 8L/month while promoting green mobility." },
              { name: "Priya Sharma", city: "Jaipur", quote: "KGV's support system is exceptional. They truly care about their distributors." },
              { name: "Amit Patel", city: "Ahmedabad", quote: "The exclusive territory policy ensures healthy growth without competition." }
            ].map((testimonial, index) => (
              <div key={index} className="bg-white p-6 rounded-2xl shadow-lg border border-green-100">
                <div className="text-yellow-400 text-2xl mb-2">★★★★★</div>
                <p className="text-gray-600 italic mb-4">"{testimonial.quote}"</p>
                <div className="flex items-center justify-between">
                  <div>
                    <div className="font-bold text-gray-800">{testimonial.name}</div>
                    <div className="text-sm text-gray-500">{testimonial.city}</div>
                  </div>
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                    <span className="text-green-600 font-bold">KGV</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA Section */}
        <div className="bg-gradient-to-r from-green-600 to-green-700 rounded-3xl p-8 md:p-12 text-center max-w-6xl mx-auto shadow-2xl">
          <h3 className="text-3xl font-bold text-white mb-4">
            Ready to Start Your Journey?
          </h3>
          <p className="text-green-100 text-lg mb-6 max-w-2xl mx-auto">
            Join 500+ successful distributors across India who are building profitable businesses while making a positive impact on the environment.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-white text-green-700 px-8 py-3 rounded-full font-bold text-lg hover:bg-green-50 transform hover:-translate-y-1 transition-all duration-300 shadow-lg">
              📞 Call Now: +91 11 4995 2135
            </button>
            <button className="bg-green-800 text-white px-8 py-3 rounded-full font-bold text-lg hover:bg-green-900 transform hover:-translate-y-1 transition-all duration-300 shadow-lg">
              📧 Email: team@kgvl.co.in
            </button>
          </div>
          <p className="text-green-200 text-sm mt-6">
            Application review within 48 hours • Zero registration fee • Complete training provided
          </p>
        </div>

      </div>

      {/* Add these styles for animations */}
      <style jsx>{`
        @keyframes shimmerSweep {
          0% { transform: translateX(-100%); }
          50% { transform: translateX(100%); }
          100% { transform: translateX(100%); }
        }
        .shimmer-sweep {
          animation: shimmerSweep 3s infinite linear;
        }

        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
        
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        
        .animate-float {
          animation: float 6s ease-in-out infinite;
        }
        
        .animate-fade-in {
          animation: fadeIn 1s ease-out;
        }
      `}</style>
    </div>
  );
};

export default Distrubuter;